<template>
  <div v-loading="loadingStatus" class="google-login-wrapper" :element-loading-text="$t('portals.list.chargementDonnees')">
    <el-dialog
      class="dialogGoogleLocations"
      style="text-align: left;"
      :visible.sync="dialogGoogleLocations"
      append-to-body
    >
      <span slot="title">{{ $t("socialNetworks.dialogLocationsSelection") }}</span>
      <div
        class="dialog-google-locations-body"
        v-loading="loadingLocations"
        :element-loading-text="$t('portals.list.chargementDonnees')"
      >
        <el-form>
          <el-input
              v-model="searchQuery"
              :placeholder="$t('Rechercher par nom...')"
              clearable
              style="margin-bottom: 20px;"
          ></el-input>
          <el-radio-group v-model="choixGoogleLocation">
            <div v-for="location in filteredLocations" :key="location.name">
              <el-row>
                <el-col :md="24">
                  <el-radio :label="location.name">
                    <div>{{ location.title }}</div>
                    <div><a :href="location.websiteUri" target="_blank">{{ location.websiteUri }}</a></div>
                    <br />
                  </el-radio>
                </el-col>
              </el-row>
            </div>
          </el-radio-group>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveLocationGoogle" :disabled="loadingLocations"><span>{{ $t("portals.list.confirm") }}</span></el-button>
      </span>
    </el-dialog>
    <div v-if="!hideButtons">
      <div v-if="issetTokenUtilisateur">
        <div v-if="locationSelected">
          <span style="padding: 10px;">{{ locationSelected.title }}</span>
          <a v-if="locationSelected.websiteUri" :href="locationSelected.websiteUri" target="_blank">{{ locationSelected.websiteUri }}</a>
        </div>
        <el-button @click="deconnexionGoogle" type="primary" class="inline">{{ $t("socialNetworks.googleDeconnexion") }}</el-button>
      </div>
      <div v-else>
        <button @click="authenticate('google')" class="gsi-material-button" :disabled="loadingStatus">
          <div class="gsi-material-button-state"></div>
          <div class="gsi-material-button-content-wrapper">
            <div class="gsi-material-button-icon">
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                <path fill="none" d="M0 0h48v48H0z"></path>
              </svg>
            </div>
            <span class="gsi-material-button-contents">Sign in with Google</span>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import { getTokenUtilisateur, recordDiffusionsGoogle } from '@/services/tokenUtilisateurApi'
import { getDiffusionAnnonceurByCodeName } from '@/services/portals'

export default {
  name: 'googleLogin',
  props: {
    // Masque les boutons natifs : la page parente affiche les CTA design et appelle login/logout via ref
    hideButtons: { type: Boolean, default: false }
  },
  data () {
    return {
      dialogGoogleLocations: false,
      choixGoogleLocation: null,
      locationsGoogle: [],
      filteredLocations: [],
      loadingStatus: false,
      loadingLocations: false,
      issetTokenUtilisateur: false,
      locationSelected: null,
      searchQuery: '',
      searchTimeout: null
    }
  },
  watch: {
    // Ce watcher s'exécutera chaque fois que searchQuery change
    searchQuery (newValue) {
      // Annule le précédent timeout si l'utilisateur tape rapidement
      clearTimeout(this.searchTimeout)
      // Crée un nouveau timeout
      this.searchTimeout = setTimeout(() => {
        // Condition : recherche si plus de 2 caractères ou si le champ est vide
        if (newValue.length >= 3 || newValue.length === 0) {
          this.filterLocationsList(newValue)
        }
      }, 500) // Attend 500ms après la dernière frappe avant de filtrer
    },
    issetTokenUtilisateur (value) {
      this.$emit('connection-change', value)
    },
    locationSelected (value) {
      this.$emit('location-change', value)
    }
  },
  computed: {
    user () {
      return this.$store.state.app.user
    }
  },
  beforeMount () {
    getTokenUtilisateur('GOOGLE').then(tokenUtilisateur => {
      if (tokenUtilisateur && tokenUtilisateur.token) {
        this.issetTokenUtilisateur = true
      }
      this.$emit('connection-change', this.issetTokenUtilisateur)
    })
    this.handleLocation()
  },
  methods: {
    login () {
      return this.authenticate('google')
    },
    logout () {
      return this.deconnexionGoogle()
    },
    filterLocationsList(search) {
      const searchTerm = (search || '')
          .normalize('NFD') // Sépare les caractères de base de leurs accents (ex: "é" -> "e" + "'")
          .replace(/[\u0300-\u036f]/g, '') // Supprime les diacritiques/accents
          .toLowerCase()

      if (!searchTerm) {
        this.filteredLocations = Array.isArray(this.locationsGoogle) ? this.locationsGoogle : []
        return
      }

      if (!Array.isArray(this.locationsGoogle)) {
        this.filteredLocations = []
        return
      }

      this.filteredLocations = this.locationsGoogle.filter(location => {
        // S'assurer que le titre est bien une chaîne de caractères non vide
        if (!location || typeof location.title !== 'string' || location.title.length === 0) {
          return false
        }

        // 2. Normaliser le titre de la même manière que le terme de recherche
        const normalizedTitle = location.title
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()

        // 3. Effectuer la comparaison sur les chaînes normalisées
        return normalizedTitle.includes(searchTerm)
      })
    },
    async authenticate (provider) {
      this.loadingStatus = true
      try {
        const data = await this.$auth.authenticate(provider)
        if (data.data && data.data.access_token) {
          await this.saveToken(data.data.access_token)
        }
      } catch (error) {
        console.error(error)
        this.dialogGoogleLocations = false
        this.loadingLocations = false
      } finally {
        this.loadingStatus = false
      }
    },
    async saveToken (accessToken) {
      this.choixGoogleLocation = null
      this.locationsGoogle = []
      this.filteredLocations = []
      this.dialogGoogleLocations = true
      this.loadingLocations = true
      try {
        await HTTP_HYPER_ESPACE_BACKEND.post('/google/saveToken', { data_token: accessToken })
        this.issetTokenUtilisateur = true
        const locations = await this.getLocations()
        if (locations) {
          this.locationsGoogle = locations.locations
          this.filteredLocations = locations.locations
        } else {
          this.dialogGoogleLocations = false
          this.$message({ message: this.$t('error locations'), type: 'error' })
        }
      } catch (error) {
        this.dialogGoogleLocations = false
        this.$message({ message: this.$t('error fetching locations'), type: 'error' })
        console.error(error)
        throw error
      } finally {
        this.loadingLocations = false
      }
    },
    getLocations () {
      return HTTP_HYPER_ESPACE_BACKEND.get('/google/locations').then(response => {
        return response.data
      })
    },
    async handleLocation () {
      const googleData = this.user.socialNetworkCodenames.find((element) => element[1].includes('GOOGLE'))
      if (googleData && googleData[1]) {
        const googleDiffusion = await getDiffusionAnnonceurByCodeName(googleData[1])
        if (googleDiffusion && googleDiffusion.infos && googleDiffusion.infos._embedded
            && googleDiffusion.infos._embedded.diffusion_annonceur && googleDiffusion.infos._embedded.diffusion_annonceur.length > 0) {
          const locationsId = googleDiffusion.infos._embedded.diffusion_annonceur[0].identifiants[2].valeur
          if (locationsId) {
            this.getLocations().then(locations => {
              if (locations) {
                for (const locationKey in locations.locations) {
                  const locationSelected = locations.locations[locationKey]
                  if (locationSelected.name === 'locations/' + locationsId) {
                    this.locationSelected = locationSelected
                    break
                  }
                }
              }
            })
          }
        }
      }
    },
    async saveLocationGoogle () {
      if (!this.choixGoogleLocation) {
        return
      }
      this.loadingStatus = true
      try {
        this.dialogGoogleLocations = false
        for (const locationKey in this.locationsGoogle) {
          const locationChoice = this.locationsGoogle[locationKey]
          if (locationChoice.name === this.choixGoogleLocation) {
            await recordDiffusionsGoogle(locationChoice)
            this.locationSelected = locationChoice
            break
          }
        }
        this.$message({ message: this.$t('Établissement Google sélectionné'), type: 'success' })
      } finally {
        this.loadingStatus = false
      }
    },
    async deconnexionGoogle () {
      this.loadingStatus = true
      try {
        await HTTP_HYPER_ESPACE_BACKEND.post('/google/remove')
        this.locationSelected = null
        this.issetTokenUtilisateur = false
        this.$message({ message: this.$t('Google déconnecté'), type: 'success' })
      } finally {
        this.loadingStatus = false
      }
    }
  }
}
</script>
<style>
  .google-login-wrapper {
    min-height: 48px;
    position: relative;
  }

  .dialog-google-locations-body {
    min-height: 200px;
    position: relative;
  }

  .gsi-material-button {
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -webkit-appearance: none;
    background-color: WHITE;
    background-image: none;
    border: 1px solid #747775;
    -webkit-border-radius: 4px;
    border-radius: 4px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #1f1f1f;
    cursor: pointer;
    font-family: 'Roboto', arial, sans-serif;
    font-size: 14px;
    height: 40px;
    letter-spacing: 0.25px;
    outline: none;
    overflow: hidden;
    padding: 0 12px;
    position: relative;
    text-align: center;
    -webkit-transition: background-color .218s, border-color .218s, box-shadow .218s;
    transition: background-color .218s, border-color .218s, box-shadow .218s;
    vertical-align: middle;
    white-space: nowrap;
    width: auto;
    max-width: 400px;
    min-width: min-content;
  }

  .gsi-material-button .gsi-material-button-icon {
    height: 20px;
    margin-right: 12px;
    min-width: 20px;
    width: 20px;
  }

  .gsi-material-button .gsi-material-button-content-wrapper {
    -webkit-align-items: center;
    align-items: center;
    display: flex;
    -webkit-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: nowrap;
    flex-wrap: nowrap;
    height: 100%;
    justify-content: space-between;
    position: relative;
    width: 100%;
  }

  .gsi-material-button .gsi-material-button-contents {
    -webkit-flex-grow: 1;
    flex-grow: 1;
    font-family: 'Roboto', arial, sans-serif;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
  }

  .gsi-material-button .gsi-material-button-state {
    -webkit-transition: opacity .218s;
    transition: opacity .218s;
    bottom: 0;
    left: 0;
    opacity: 0;
    position: absolute;
    right: 0;
    top: 0;
  }

  .gsi-material-button:disabled {
    cursor: default;
    background-color: #ffffff61;
    border-color: #1f1f1f1f;
  }

  .gsi-material-button:disabled .gsi-material-button-contents {
    opacity: 38%;
  }

  .gsi-material-button:disabled .gsi-material-button-icon {
    opacity: 38%;
  }

  .gsi-material-button:not(:disabled):active .gsi-material-button-state,
  .gsi-material-button:not(:disabled):focus .gsi-material-button-state {
    background-color: #303030;
    opacity: 12%;
  }

  .gsi-material-button:not(:disabled):hover {
    -webkit-box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
    box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
  }

  .gsi-material-button:not(:disabled):hover .gsi-material-button-state {
    background-color: #303030;
    opacity: 8%;
  }
</style>
